<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<select-form v-model="form.category_id" :value="form.category_id" name="Categoria"
							url="/arquivos?cat=2" id="cod" titulo="nome" layout="true" optionText="Selecione"
							required="true"></select-form>
					</div>
					<input-form-text textInput="Título" :required="true" v-model="form.title"
						:value="form.title"></input-form-text>
					<input-form-text textInput="Url" v-model="form.url" :value="form.url"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Duração</label>
						<div class="col-sm-5">
							<select class="form-control" v-model="form.duracao">
								<option v-for="option in duracaoOptions" :key="option.value" :value="option.value">
									{{ option.label }}
								</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Período</label>
						<div class="col-sm-9">
							<date-range-picker :opens="opens" @update="updateValues" :locale-data="locale"
								:startDate="startDate" :endDate="endDate" :rangesOpen="false"></date-range-picker>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages.length" ref="fupload" :url="'/publicidades/upload'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false"></file-upload>
							<items-edit v-else :files="allImages"
								url="/publicidades/upload"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.active" :value="form.active" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import DateRangePicker from '@/components/form/DateRangePicker/DateRangePicker'
import { sucesso, erro } from '@/components/Message'
import moment from 'moment'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		DateRangePicker,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Publicidades',
			form: {
				title: '',
				url: '',
				date_initial: moment().format('YYYY-MM-DD'),
				date_final: moment().format('YYYY-MM-DD'),
				active: '1',
				category_id: '',
				images: '',
				duracao: 10
			},
			duracaoOptions: [
				{ label: '1 segundo', value: 1 },
				{ label: '3 segundos', value: 3 },
				{ label: '5 segundos', value: 5 },
				{ label: '10 segundos', value: 10 },
				{ label: '15 segundos', value: 15 },
				{ label: '20 segundos', value: 20 },
				{ label: '25 segundos', value: 25 },
				{ label: '30 segundos', value: 30 }
			],
			allImages: [],
			opens: 'ltr',
			locale: {
				direction: 'ltr',
				format: 'DD/MM/YYYY',
				separator: ' - ',
				applyLabel: 'Aplicar',
				cancelLabel: 'Cancelar',
				weekLabel: 'W',
				customRangeLabel: 'Custom Range',
				daysOfWeek: moment.weekdaysMin(),
				monthNames: moment.monthsShort(),
				firstDay: 1,
				open: true
			},
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		getRetornoImg() {

		},
		updateValues(values) {
			this.form.date_initial = moment(values.startDate).format('YYYY-MM-DD')
			this.form.date_final = moment(values.endDate).format('YYYY-MM-DD')
		},
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				let resp = await req(`/publicidades/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				if (!this.allImages.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/publicidades')
			} else {
				let resp = await req('/publicidades', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/publicidades')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		getDados() {
			req(`/publicidades/${this.$route.params.id}`).then(resp => {
				this.form.active = resp.active
				this.form.title = resp.title
				this.form.url = resp.url
				this.form.date_initial = resp.date_initial
				this.form.date_final = resp.date_final
				this.form.category_id = resp.category_id
				this.form.duracao = resp.duracao || 10
				this.allImages = resp.images ? [{ id: this.$route.params.id, images: resp.images }] : ''
				this.isActive = false
			}).catch(() => {
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
